import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollToHash(hash: string) {
  const id = decodeURIComponent(hash.replace(/^#/, ''));
  const target = document.getElementById(id);
  if (!target) return;

  target.scrollIntoView({ block: 'start', inline: 'nearest' });
}

export function ScrollRestoration() {
  const { pathname, hash, key } = useLocation();

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return;
    }

    const frame = window.requestAnimationFrame(() => scrollToHash(hash));
    const retry = window.setTimeout(() => scrollToHash(hash), 80);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(retry);
    };
  }, [pathname, hash, key]);

  return null;
}
